<template>
  <div
    data-scroll-to-active="true"
    class="main-menu menu-fixed menu-dark menu-accordion menu-shadow"
  >
    <div class="main-menu-header"></div>
    <div class="main-menu-content">
      <ul
        id="main-menu-navigation"
        data-menu="menu-navigation"
        class="navigation navigation-main"
      >
        <LeftMenuItem
          v-if="isMainPageVisible && !isDriver"
          title="Главная"
          path="/"
          iconClassName="icon-home3"
        />
        <LeftMenuItem
          v-if="isDriverMainPageVisible"
          title="Главная"
          path="/"
          iconClassName="icon-home3"
        />

        <template v-if="!isDriver">
          <li
            v-if="
              (isFuelCardsEnabled || isTicketsEnabled || isDiscountCardsVisible)
            "
            class="navigation-header"
          >
            <span><b>КАРТЫ и ТАЛОНЫ</b></span>
            <i
              data-toggle="tooltip"
              data-placement="right"
              data-original-title="Карты и талоны"
              class="icon-ellipsis"
            ></i>
          </li>
          <LeftMenuItem
            v-if="isFuelCardsEnabled"
            title="Топливные карты"
            path="/cards"
            iconClassName="icon-bankcard"
          />
          <LeftMenuItem
            v-if="isDiscountCardsVisible"
            title="Дисконтные карты"
            path="/discount"
            iconClassName="icon-credit-card2"
          />
          <LeftMenuItem
            v-if="isTicketsEnabled"
            title="Топливные талоны"
            path="/tickets"
            iconClassName="icon-barcode"
          />
        </template>

        <li class="navigation-header" v-if="isWorkExternalOrdersEnabled">
          <span><b>ЗАПРАВКИ</b></span>
          <i
            data-toggle="tooltip"
            data-placement="right"
            data-original-title="Заправки"
            class="icon-ellipsis"
          ></i>
        </li>
        <LeftMenuItem
          v-if="isWorkExternalOrdersEnabled"
          title="Новая заправка"
          path="/orders/new"
          iconClassName="icon-timeline"
        />
        <LeftMenuItem
          v-if="isWorkExternalOrdersEnabled"
          title="История заправок"
          path="/orders"
          iconClassName="icon-timeline"
        />

        <template v-if="!isDriver">
          <li
            v-if="(isRequestsEnabled || isWorkOrdersEnabled) && isMainPageVisible"
            class="navigation-header"
          >
            <span><b>ФИНАНСЫ</b></span>
            <i
              data-toggle="tooltip"
              data-placement="right"
              data-original-title="Финансы"
              class="icon-ellipsis"
            ></i>
          </li>

          <LeftMenuItem
            v-if="isRequestsEnabled"
            title="Заявки и счета"
            path="/requests"
            iconClassName="icon-android-textsms"
          />
          <LeftMenuItem
            v-if="isWorkOrdersEnabled"
            title="Наряды"
            path="/workorders"
            iconClassName="icon-android-textsms"
          />
        </template>
        <!--LeftMenuItem
          title="Счета на оплату"
          path="/bills"
          iconClassName="icon-file-text2"
          notifyTagColor="tag-info"
        />
        <LeftMenuItem
          title="Накладные"
          path="/waybills"
          iconClassName="icon-paste2"
          notifyTagColor="tag-success"
          :notify="newWaybillsCount"
        />
        <LeftMenuItem
          title="Счета-фактуры"
          path="/invoices"
          iconClassName="icon-file-text3"
          notifyTagColor="tag-primary"
          :notify="newInvoicesCount"
        /-->
      </ul>
    </div>
  </div>
</template>

<script>
import LeftMenuItem from "@/components/LeftMenuItem.vue";
import { mapGetters } from "vuex";

import { CONFIG_REQUEST } from "@/store/actions/config";

export default {
  name: "LeftMenu",
  components: {
    LeftMenuItem,
  },
  computed: {
    ...mapGetters([
      "isFiz",
      /*
      'newBillsCount',
      'newWaybillsCount',
      'newInvoicesCount',*/

      "getConfig",
      "isConfigLoading",
      "configOnceLoaded",

      "isWorkOrdersEnabled",
      "isWorkExternalOrdersEnabled",
      "isDiscountCardsEnabled",
      "isFuelCardsEnabled",
      "isTicketsEnabled",
      "isRequestsEnabled",

      "isDriver",
    ]),
    isDiscountCardsVisible() {
      return this.isFiz && this.isDiscountCardsEnabled;
    },
    isMainPageVisible() {
      return (
        this.isRequestsEnabled ||
        this.isFuelCardsEnabled ||
        this.isDiscountCardsVisible ||
        this.isTicketsEnabled
      );
    },
    isDriverMainPageVisible() {
      return (
          this.isDriver
      );
    },
  },
  created() {
    //console.log('MENU created()');
    if (!this.configOnceLoaded) this.$store.dispatch(CONFIG_REQUEST);
  },
  mounted() {
    //$.app.menu.init();    
    let _jq = this.jQuery;

    console.log(_jq);
    if (_jq)
    {
      console.log(_jq.app);
      if (_jq.app.menu)
        _jq.app.menu.init();
    }
  },
};
</script>

<style></style>
